const color = {
  $white: '#fff',
  $black: '#000'
};

export default color;
